import React from "react";
import * as s from "./PDFDownloadBlockMobile.module.css";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import { webhookEvents, formValidation } from "../../../utils/webhookService";

const PDFDownloadBlockMobile = ({ block, post }) => {

  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");

  const [email, setEmail] = React.useState("");
  const [acceptChecked, setAcceptChecked] = React.useState(false);
  const [errors, setErrors] = React.useState({
    firstName: null,
    lastName: null,
    email: null,
  });
  const [messageSent, setMessageSent] = React.useState(false);

  const handleAcceptCheckboxChange = (e) => {
    setAcceptChecked(e.target.checked);
  }
  const mobileImage = {
    data: block.mobileImage?.localFile?.childImageSharp?.gatsbyImageData,
    alt: block.mobileImage?.alt || ``,
  };
  const submitForm = (e) => {
    if (isValidForm()) {
      setMessageSent(true);

      const formData = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        post: post,
      };

      webhookEvents.pdfDownload(formData, {
        onSuccess: () => {
          setFirstName("");
          setLastName("");
          setEmail("");
          setErrors({
            firstName: null,
            lastName: null,
            email: null,
          });
          setMessageSent(true);
        },
        onError: (error) => {
          console.error("PDF Download form submission failed:", error);
          setMessageSent(false);
        }
      });

      const element = document.createElement("a");
      element.href = block?.file?.localFile?.publicURL;
      element.download = block?.file?.localFile?.base;
      element.click();
    }
  }

  const isValidForm = () => {
    const fields = { firstName, lastName, email };
    const validationRules = {
      firstName: {
        required: true,
        notEmpty: true,
        requiredMessage: 'Please enter Your First Name'
      },
      lastName: {
        required: true,
        notEmpty: true,
        requiredMessage: 'Please enter Your Last Name'
      },
      email: {
        required: true,
        email: true,
        requiredMessage: 'Please enter a valid Email'
      }
    };

    const { isValid, errors } = formValidation.validateRequiredFields(fields, validationRules);
    setErrors(errors);
    return isValid;
  }

  if (block?.show) {
    return (
      <div className={`${s.pdfDownloadBlock}`}>
        <div className='container px-0'>
          <div className='row mx-0'>
            <div className='col-12 ps-lg-0'>
              <div className="imageWrapper position-relative">
                {!!mobileImage?.data ? (
                  <GatsbyImage
                    placeholder="none"
                    loading="eager"
                    image={mobileImage.data}
                    alt={mobileImage.alt}
                    className={`${s.mobileImage}`}
                  />
                ) : <StaticImage
                  placeholder="none"
                  loading="eager"
                  className={`${s.mobileImage}`}
                  alt="form image"
                  src="./mobile.png" />}
              </div>
            </div>
            <div className='col-12 pe-0 mt-4 mt-0'>
              <div className="row">
                <div className="col-12">
                  <h3 className={s.title}>Receive Actionable Tips Immediately!</h3>
                </div>
                <div className="col-12">
                  <div className={`${s.labelInputGroup}`}>
                    <div className={s.inputWrapper}>
                      <label>First Name</label>
                      <input
                        className={`${null != errors.firstName && s.invalid}`}
                        type="text"
                        name="firstname"
                        value={firstName}
                        onChange={e => setFirstName(e.target.value)}
                      />
                      {/* {null != errors.firstName && <small style={{ color: 'red' }}>{errors.firstName}</small>} */}
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className={`${s.labelInputGroup}`}>
                    <div className={s.inputWrapper}>
                      <label>Last Name</label>
                      <input
                        className={`${null != errors.lastName && s.invalid}`}
                        type="text"
                        name="lastname"
                        value={lastName}
                        onChange={e => setLastName(e.target.value)}
                      />
                      {/* {null != errors.lastName && <small style={{ color: 'red' }}>{errors.lastName}</small>} */}
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className={`${s.labelInputGroup} w-100`}>
                    <div className={s.inputWrapper}>
                      <label>Email</label>
                      <input
                        className={`${null != errors.email && s.invalid}`}
                        type="email"
                        name="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                      />
                      {/* {null != errors.email && <small style={{ color: 'red' }}>{errors.email}</small>} */}
                    </div>
                  </div>
                </div>



                <div className="col-12">
                  <label className={`${s.labelCheckboxGroup} w-100`}>
                    <input type="checkbox" onChange={handleAcceptCheckboxChange} />
                    I have read and accept the &nbsp;<a href="/privacy-policy" target="_blank"> Privacy Policy</a>.
                  </label>
                </div>
                <div className="col-12">
                  <button type="submit" disabled={!acceptChecked} className={`${s.sendButton}`} onClick={submitForm}>
                    Download PDF
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    );
  }
  return <></>
};

export default PDFDownloadBlockMobile;
